import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./about.css";
import aboutImage from "../assets/images/about-us.jpg";

const About = () => {
  useEffect(() => {
    const handleScroll = () => {
      const section = document.querySelector(".about-section");
      const position = section.getBoundingClientRect().top;
      const screenHeight = window.innerHeight;

      if (position < screenHeight - 100) {
        section.classList.add("show");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section className="about-section">
      <div className="container">
        <div className="row align-items-center about-row">
          {/* Image Column */}
          <div className="col-lg-5 mb-4 mb-lg-0 about-img">
            <img
              src={aboutImage}
              alt="About Us"
              className="img-fluid shadow rounded"
            />
          </div>

          {/* Text Column */}
          <div className="col-lg-7 about-content">
            <h2 className="section-title">About us</h2>
            <p className="lead fw-semibold tagline">
              Financial emergencies don’t wait. Neither do we.
            </p>

            <p>
              At Vanshika Micro Credit, we are revolutionizing borrowing in India by offering fast, simple, and hassle-free Ultra Short Term Loans tailored for salaried individuals in urgent need. Our services eliminate paperwork, bias, and delays, delivering instant financial support when you need it most.
We understand that awaiting your salary date is not an option when life demands urgent attention —be it medical expenses, overdue bills, or family responsibilities. Vanshika Micro Credit is your trusted partner, committed to providing transparent, compliant, and responsible lending solutions designed around your needs.

            </p>
            <Link to="/about-us" className="btn btn-custom-primary mt-2">
              More About Us
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
